import { ChakraProvider } from "@chakra-ui/react";
import Home from "views/Home";
import theme from './theme'

const App = () => {
	return (
		<ChakraProvider theme={theme} initialColorMode={theme.config.initialColorMode}>
			<Home />
		</ChakraProvider>
	);
};

export default App;
